<template>
  <nav class="c-nav--main">
    TEST
    <ul>
      <li v-for="item in getItemsByLevel" v-bind:key=item.id>
        <Button nupsi>{{ item.name }}</Button>
      </li>
    </ul>
  </nav>
</template>

<script>
import Button from '@/components/atoms/Button'
import { mapState, mapActions } from 'vuex'

import Vue from 'vue'
export default Vue.extend({
  name: 'MainNavigation',
  components: { Button },
  methods: {
    ...mapActions('categories', [
      'fetchItems'
    ]),
    getItemsByParentId (parentId) {
      return this.$store.getters['categories/getItemsByParentId'](parentId)
    }
  },
  computed: {
    ...mapState('categories', [
      'items',
      'itemsLoading'
    ]),
    getItemsByLevel () {
      return this.$store.getters['categories/getItemsByLevel'](2)
    }
  }
})
</script>

<style scoped lang="sass">
  .c-nav
    &--main
      text-align: center
      ul
        margin: 0px
        padding: 0
        font-size: 1em
      li
        list-style: none
        //@include span-columns(12/5)
        //@include omega(5n)
</style>
